// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9tuCo","tabsBox":"styles_tabsBox__2noyF","createButton":"styles_createButton__3FHGZ"};